import React, { useEffect } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/LandingPage/Footer/Footer";
import termsData from "./termsData"; // Adjust the path based on your directory structure
import CommonLayout from "../CommonLayout/CommonLayout";

const TermsAndConditionsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [])
      return (
        <main>
          <Navbar />
          <CommonLayout data={termsData} />
          <Footer />
        </main>
      );
};


export default TermsAndConditionsPage;
